import { render, staticRenderFns } from "./ExpensesContent.vue?vue&type=template&id=4d3ce4cc&"
import script from "./ExpensesContent.vue?vue&type=script&lang=js&"
export * from "./ExpensesContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports